export default __webpack_public_path__ + "static/media/step-11.a03cdbb1.png";